<template>
  <div v-if="details" class="generation-failure-details" :title="tooltip" role="alert">
    <i class="el-icon-warning-outline" aria-hidden="true"></i>
    <div><strong>失败原因</strong><span><code v-if="details.code">{{ details.code }}</code>{{ details.message }}</span><small v-if="details.suggestion">{{ details.suggestion }}</small></div>
  </div>
</template>
<script>
export default {
  name: 'GenerationFailureDetails',
  props: { record: { type: Object, default: null } },
  computed: {
    details() {
      const record = this.record
      if (!record || record.status !== 'failed') return null
      const tasks = record.taskStates || record.tasks || []
      const failedTask = tasks.find(task => task && task.status === 'failed')
      const source = failedTask && failedTask.error ? failedTask.error : {}
      const message = source.message || source.error || record.errorMessage || record.error || '中转站未返回具体失败原因，请刷新记录或联系管理员查询任务编号'
      return { code: source.code || record.errorCode || '', message: String(message).trim(), suggestion: source.suggestion || record.errorSuggestion || '' }
    },
    tooltip() { return this.details ? [this.details.code, this.details.message, this.details.suggestion].filter(Boolean).join(' · ') : '' }
  }
}
</script>
<style scoped>
.generation-failure-details{display:flex;align-items:flex-start;gap:7px;margin:8px 10px;border:1px solid #f0c5c1;border-radius:6px;padding:8px 9px;background:#fff3f2;color:#a53a34;text-align:left;line-height:1.45}.generation-failure-details>i{flex:0 0 auto;margin-top:2px}.generation-failure-details>div{min-width:0;display:flex;flex-direction:column;gap:3px}.generation-failure-details strong{font-size:9px}.generation-failure-details span{overflow-wrap:anywhere;font-size:9px}.generation-failure-details code{display:inline-block;margin-right:5px;border:1px solid #efc5c2;border-radius:3px;padding:1px 4px;background:#fff;color:#922f2a;font:8px ui-monospace,SFMono-Regular,Consolas,monospace}.generation-failure-details small{color:#a9615c;font-size:8px}
</style>
